export default "__VITE_ASSET__3187a216__"